/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_Key_PointsInputs */

const en_read_along_ai_key_points = /** @type {(inputs: Read_Along_Ai_Key_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key points`)
};

const es_read_along_ai_key_points = /** @type {(inputs: Read_Along_Ai_Key_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntos clave`)
};

/**
* | output |
* | --- |
* | "Key points" |
*
* @param {Read_Along_Ai_Key_PointsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_key_points = /** @type {((inputs?: Read_Along_Ai_Key_PointsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_Key_PointsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_key_points(inputs)
	return en_read_along_ai_key_points(inputs)
});